module.exports = __webpack_public_path__ + "static/media/lascalles02_small@2x.9807a24e.jpg";